import algoliasearch from 'algoliasearch/lite'

// Memoises clients per appId+apiKey pair so callers (including render methods)
// can call this repeatedly without leaking client instances.
const clientCache = new Map()

export function getAlgoliaClient(appId, apiKey) {
  const cacheKey = `${appId}:${apiKey}`
  if (!clientCache.has(cacheKey)) {
    clientCache.set(cacheKey, algoliasearch(appId, apiKey))
  }
  return clientCache.get(cacheKey)
}
